<template>
  <router-view />
</template>

<script>
export default {
  name: "PrepProcessSingle"
};
</script>
